import React, { createContext, useState, ReactNode } from 'react';

interface TeamContextType {
    teamSelected: string | null;
    setTeamSelected: (team: string | null) => void;
}

// Create the context
export const TeamContext = createContext<TeamContextType>({
    teamSelected: null,
    setTeamSelected: () => {},
});

interface TeamProviderProps {
    children: ReactNode;
}

// Create a provider component
export const TeamProvider: React.FC<TeamProviderProps> = ({ children }) => {
    const [teamSelected, setTeamSelected] = useState<string | null>(null);

    return (
        <TeamContext.Provider value={{ teamSelected, setTeamSelected }}>
            {children}
        </TeamContext.Provider>
    );
};
